export default "__VITE_ASSET__BRt34Q9v__"